import { render, staticRenderFns } from "./PurchaseHistoryModal.vue?vue&type=template&id=0966aa20&"
import script from "./PurchaseHistoryModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports